<bc-modal 
[title]="title" 
[displayButton]="false" 
[typeIcon]="typeIcon" 
[customWidth]="customWidth" 
titleAlign="center"
[isCancellable]='action'
#modalShared>
    <div modalContent class="bc-text-center">
        <div class="bc-row">
            <div class="bc-col-12">
                <span>{{ body }}</span>
            </div>
        </div>
        <div class="bc-row bc-mt-5">
            <div class="bc-col-12">
                <span>{{ subBody }}</span>
            </div>
        </div>
    </div>
</bc-modal>